import { Component } from '@grafikr/components';
import fastdom from 'fastdom';

export default Component((node) => {
  const heightThreshold = node.offsetHeight;
  let isBelowHeader = window.scrollY > heightThreshold;

  window.addEventListener('scroll', () => {
    fastdom.measure(() => {
      isBelowHeader = window.scrollY > heightThreshold;
    });
    fastdom.mutate(() => {
      if (isBelowHeader) {
        node.classList.add('header--scrolled');
      } else {
        node.classList.remove('header--scrolled');
      }
    });
  });
});
